import QueryServicePage from "./LookupTn";

export default QueryServicePage;
